
const ManageUsers = ()=>{

    return(
        <h1>Cost Management Admin Page</h1>
    )
}
export default ManageUsers;